import styled from "styled-components";

// Define interface for component props (can be extended if needed)
interface EmployeeSalaryWrapperProps {
  className?: string;
}

const EmployeeSalaryWrapper = styled.div<EmployeeSalaryWrapperProps>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0px 20px 40px 20px;
  .header_container {
    display: flex;
  }
  .header_details_container {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .ant-badge-status-text {
      font-size: 30px;
    }
    h1.ant-typography {
      margin: 0;
      text-decoration: underline;
    }
  }
  .ant-table {
    .salary_summary td {
      font-weight: bold;
      span {
        font-weight: bold;
      }
    }
    tr.salary_collapsed {
      background: #f8f8f8;
      &:hover {
        background: #f8f8f8;
      }
      td {
        background: #f8f8f8;
        &:hover {
          background: #f8f8f8;
        }
      }
    }
  }
  .details {
    display: flex;
    padding-top: 20px;
    .details_item {
      border-radius: 5px;
      border: 1px dashed rgba(120, 120, 120, 0.32);
      display: flex;
      flex-direction: column;
      padding: 5px 10px;
      height: fit-content;
    }
    .ant-typography + h5.ant-typography {
      margin: 0;
    }
  }
  .spacer {
    width: 20px;
    height: 20px;
  }
  .avatar {
    width: 100px;
    height: 100px;
  }
`;

export default EmployeeSalaryWrapper;
